
import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName, month } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels_With_Year from "./Models/Filter_MonthDowRoomTypeRatePlanChannels_With_Year";
import { Bar, Line, Pie, Chart as ReactChart } from "react-chartjs-2";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
} from "chart.js";
import ChartDataAsTable from "../ChartDataAsTable";
import horizobtalBarIcon from "../../../../Assets/Images/Revenue-management/horizontal-bars.svg";
import graphIcon from "../../../../Assets/Images/Revenue-management/graphIcon.svg";

const Patterns_DOWPatternADR = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    topfilterdata,
    topviewoption
}) => {
    const [viewOption, setViewOption] = useState("Graph");

    useEffect(() => {
        if (topviewoption) {
            setViewOption(topviewoption)
        }
    }, [topviewoption]);
    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => { setWidgetModal(false); };

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [CurrentYearData, setCurrentYearData] = useState([]);

    const [FinalData, setFinalData] = useState({
        data: {
            labels: [],
            datasets: []
        },
        options: {

        }
    });

    const GetCurrentYearData = async () => {
        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_DOW_WISE_CONTRIBUTION,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);

            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };



    const [dataLoading, setDataLoading] = useState(false);

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {

        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, filterData]);

    useEffect(() => {
        if (topfilterdata) {
            setFilterData(topfilterdata)
        }
    }, [topfilterdata]);


    useEffect(() => {
        if (!dataLoading) {
            let _FinalData = {
                data: {
                    /* labels: [],*/
                    datasets: []
                },
                options:
                {
                    interaction: {
                        mode: "index",
                        intersect: false
                    },
                    responsive: true,
                    plugins: {
                        legend: {
                            position: "top",
                            align: "end",
                            labels: {
                                boxWidth: 14,
                            }
                        },
                        title: { display: true, text: "DoW Pattern - ADR" },
                        tooltip: {
                            callbacks: {
                                label: function (ctx) {
                                    let value = ctx.raw || 0;
                                    let label = ctx.dataset.label;
                                    return `${label} : ${value}`;
                                },
                            },
                        },
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            title: { display: false, text: "Value" },
                            ticks: {
                                callback: function (value) {
                                    return Number(value).toFixed(2);
                                    //return commonService.getAmountInCompactFormat(value);
                                },
                            },
                        },
                    },
                }
            };

            let _currentyear = {
                label: filterData.year,
                data: [],
                borderColor: "#4A90E2", // Blue line
                backgroundColor: "#4A90E2",
                tension: 0.4,
                fill: false,
                datatype: "number"
            }

            let _lastyear = {
                label: filterData.year - 1,
                data: [],
                borderColor: "#F5A623", // Orange line
                backgroundColor: "#F5A623",
                tension: 0.4,
                fill: false,
                datatype: "number"
            }

            _currentyear.data = CurrentYearData?.map((d) => Number(d.adr_contribute))
            _lastyear.data = CurrentYearData?.map((d) => Number(d.adr_ly_contribute))
            _FinalData.data.labels = CurrentYearData?.map((item) => item?.dayname);
            _FinalData.data.datasets.push(_currentyear);
            _FinalData.data.datasets.push(_lastyear)
            setFinalData(_FinalData);
        }
    }, [dataLoading]);

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    {
                        viewOption === "Graph" ?
                            <Button id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "table", propertyCode)} className="heading-menu-btns" type="button" title="Table"
                                onClick={(e) => {
                                    setViewOption("Table")
                                }}>
                                <img
                                    src={horizobtalBarIcon}
                                    alt="Table"
                                />
                            </Button>
                            :
                            <Button id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "graph", propertyCode)} className="heading-menu-btns" type="button" title="Graph"
                                onClick={(e) => {
                                    setViewOption("Graph")
                                }}>
                                <img
                                    src={graphIcon}
                                    alt="Graph"
                                />
                            </Button>
                    }

                    {
                        !topfilterdata &&
                        <Button id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "filter", propertyCode)} className="heading-menu-btns" type="button" title="Filter"
                            onClick={(e) => {
                                ShowFilter(e);
                            }}>
                            <img
                                src={filter}
                                alt="Filter"
                            />
                        </Button>
                    }

                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "Snapshot By Month",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("Patterns_DOWPatternADR", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.id1
                            }
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-Annual Summary-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                );
                            }}
                        />
                    </Button>

                    {
                        DisplayFilter.IsDisplay &&
                        <Overlay
                            show={DisplayFilter.IsDisplay}
                            target={DisplayFilter.Target}
                            placement={DisplayFilter.Position}
                        >
                            <Popover
                                id="popover-contained"
                                className="FilterPopover"
                            >
                                <Filter_MonthDowRoomTypeRatePlanChannels_With_Year show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                            </Popover>
                        </Overlay>
                    }

                </div>
            ) }

            {
                dataLoading ? <div className="ForecastHorizontalChartInner"> <Loader /></div> :
                    <>{FinalData && (
                        <div className={`TableGraphDataContainer ${viewOption}`}>
                            <div className="ForecastHorizontalChartInner TableGraphDataContainerChart">
                                <Line
                                    type="candlestick"
                                    data={FinalData.data}
                                    options={FinalData.options}
                                />
                            </div>
                            <ChartDataAsTable ChartData={FinalData.data} ChartOption={FinalData.options} id={tblids.id1} />
                        </div>
                    )}</>
            }

            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {api !== 0 && !topfilterdata && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}
        </div>
    );
};

export default Patterns_DOWPatternADR;

